// extracted by mini-css-extract-plugin
module.exports = {"button":"jgp-1Vxmr","paused":"jgp-1pPd1","status":"jgp--O-K5","logo":"jgp-105bs"};